import api from "api";

export const getMedicalKpi = (queryParams) => {
  return api.get(`/v1/kpi/medical/coachDetails${queryParams}`);
};

export const getMedicalKpiFilterData = () => {
  return api.get(`/v1/kpi/medical/coachDetailsFilters`);
};
